module.exports = __webpack_public_path__ + "img/115.47c8200a.jpg";